/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import HttpUtils, {apiUrl, defaultOptions, handleApiCall, securedApiOptions} from './HttpUtils'
import {Routes} from '../utils/Routes'

const URI = {
    TOKEN: apiUrl(Routes.TOKEN),
    USER_PROFILE: apiUrl(Routes.USER),
    AIRTIME: apiUrl('/airtime'),
}

export const exchangeAccessCode = (accessCode) => {
    if (!accessCode) {
        return Promise.reject(new Error('Access Code was empty'))
    }

    const opts = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json;charset=UTF-8',
        },
        body: accessCode,
    }

    return handleApiCall(URI.TOKEN + '/accessCode', opts)
        .then(secret => {
            return saveTokenAndLoadProfile(secret)
        })
}

export const authenticateUniqueSession = (sessionId) => {
    if (!sessionId) {
        return Promise.reject(new Error('No sessionId provided'))
    }

    const opts = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json;charset=UTF-8',
        },
        body: sessionId,
    }

    return handleApiCall(URI.AIRTIME + '/session', opts)
        .then(secret => {
            return saveTokenAndLoadProfile(secret)
        })
}

export const signIn = (username, password) => {
    if (!username || !password) {
        return Promise.reject(new Error('Username or password was empty'))
    }
    const defaultOpts = defaultOptions()

    const opts = {
        ...defaultOpts,
        method: 'POST',
        headers: {
            ...defaultOpts.headers,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            username: username,
            password: password,
        }),
    }

    return handleApiCall(URI.TOKEN, opts)
        .then(secret => {
            return saveTokenAndLoadProfile(secret)
        })
}

export const loadUserProfile = () => {
    return handleApiCall(URI.USER_PROFILE)
}

export const signOut = () => {
    HttpUtils.cleanJwsToken()
}

export const isAuthenticated = () => {
    return HttpUtils.isAuthenticated()
}

export const setUserLanguage = (userId, lang) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = lang
    return handleApiCall(apiUrl(`users/${userId}/language`), opts)
}

export const getSSOclientId = () => {
    return handleApiCall(apiUrl(`appConfigs/client`))
}

export const acceptUserDisclaimer = () => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    return handleApiCall(apiUrl('users/acceptDisclaimer?current=true'), opts)
}

export const saveTokenAndLoadProfile = (secret) => {
    if (!secret) {
        return null
    }
    HttpUtils.saveJwsToken(secret.authToken)
    HttpUtils.saveJwsToken(secret.refreshToken, true)
    return loadUserProfile()
}